var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#50AF95"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_46_11488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.432 10.7112C19.3554 10.6144 19.2747 10.5438 19.192 10.4874C19.0287 10.3744 18.8693 10.2998 18.708 10.2373C18.3873 10.1122 18.0687 10.0356 17.748 9.96703C17.1087 9.83594 16.4693 9.77342 15.832 9.71493C15.1947 9.65241 14.5574 9.62619 13.9201 9.60199C13.7809 9.59594 13.6418 9.59392 13.5006 9.58989V7.94014H17.8629V5.04199H6.24009V7.94014H10.6024V9.58787C10.433 9.59191 10.2656 9.59594 10.0962 9.60401C9.45891 9.63023 8.8216 9.65443 8.18429 9.71695C7.54698 9.77745 6.90765 9.83796 6.26832 9.97107C5.94966 10.0376 5.62899 10.1143 5.30832 10.2413C5.14698 10.3038 4.98765 10.3764 4.82429 10.4914C4.74362 10.5479 4.66093 10.6185 4.5863 10.7153C4.51168 10.8141 4.44513 10.9533 4.43706 11.1166C4.43505 11.28 4.49353 11.4252 4.56412 11.5321C4.63471 11.6369 4.71336 11.7156 4.79202 11.7822C4.94933 11.9153 5.10664 12.006 5.26395 12.0867C5.57857 12.2501 5.89521 12.363 6.21387 12.4659C6.84916 12.6655 7.48849 12.8168 8.13185 12.9257C8.77521 13.0285 9.42059 13.1112 10.068 13.1617C10.2475 13.1738 10.427 13.1818 10.6045 13.1899V19.1475H13.5006V13.1859C13.6498 13.1778 13.8011 13.1717 13.9503 13.1617C14.5977 13.1173 15.2411 13.0285 15.8865 12.9277C16.5298 12.8228 17.1692 12.6675 17.8045 12.4679C18.1231 12.363 18.4377 12.2501 18.7544 12.0867C18.9117 12.006 19.069 11.9133 19.2263 11.7801C19.305 11.7136 19.3836 11.6329 19.4542 11.528C19.5248 11.4212 19.5833 11.2739 19.5813 11.1106C19.5732 10.9492 19.5066 10.8101 19.432 10.7112ZM18.9762 11.4615C18.8552 11.5543 18.7161 11.6289 18.5749 11.6914C18.2905 11.8205 17.986 11.9112 17.6794 11.9919C17.0663 12.1492 16.4391 12.2541 15.8098 12.3348C14.5493 12.4921 13.2787 12.5506 12.0082 12.5506C10.7376 12.5506 9.46698 12.4921 8.20647 12.3348C7.57723 12.2541 6.95 12.1512 6.33689 11.9919C6.03236 11.9112 5.72782 11.8205 5.44143 11.6914C5.29824 11.6289 5.15908 11.5543 5.04009 11.4615C4.91908 11.3707 4.81824 11.2477 4.81219 11.1126C4.81622 10.9775 4.91706 10.8524 5.03807 10.7617C5.15908 10.6669 5.29622 10.5922 5.43941 10.5297C5.72378 10.3986 6.02832 10.3059 6.33286 10.2232C6.94597 10.0618 7.5732 9.95493 8.20244 9.87224C8.99908 9.76939 9.79975 9.70888 10.6004 9.6746V12.3206C11.0683 12.3388 11.5362 12.3489 12.0041 12.3489C12.5023 12.3489 12.9984 12.3368 13.4966 12.3166V9.67863C14.269 9.71292 15.0414 9.77342 15.8078 9.87224C16.4371 9.95493 17.0643 10.0618 17.6774 10.2232C17.9819 10.3059 18.2865 10.3986 18.5708 10.5297C18.714 10.5943 18.8532 10.6689 18.9722 10.7617C19.0932 10.8524 19.194 10.9775 19.1981 11.1126C19.1981 11.2477 19.0972 11.3707 18.9762 11.4615Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_46_11488",
    x: 0.437012,
    y: 1.04199,
    width: 23.1443,
    height: 22.1056,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_46_11488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_46_11488",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtIcon);
export default __webpack_public_path__ + "static/media/usdt-icon.f1a7a9b3a75c047e6205b10e533895c0.svg";
export { ForwardRef as ReactComponent };